module.exports = __webpack_public_path__ + "static/media/4ODA12.c6a5148b.jpg";